export default {
  path: 'aggregator/requests',
  name: 'Aggregator_requests',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/AggregatorRequestsMain')
}
